

  <ul class="navbar-nav me-auto">
    <li
      [class]="item.items ? 'nav-item dropdown' : 'nav-item'"
      *ngFor="let item of tieredItems"
    >
      <a
        [routerLink]="item.routerLink ? item.routerLink : ''"
        routerLinkActive="active"
        class="nav-link"
        *ngIf="!item.items"
        ><i [class]="item?.icon"></i> {{ item.label }}
      </a>

      <a
        *ngIf="item.items"
        [routerLink]=""
        href="#"
        routerLinkActive="active"
        class="nav-link dropdown-toggle"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        ><i [class]="item?.icon"></i> {{ item.label }}
      </a>

      <ul class="dropdown-menu" *ngIf="item.items">
        <div *ngFor="let subitem of item.items; let idx = index">

          <li *ngIf="idx != 0"><hr class="dropdown-divider" /></li>
          <li>
            <a
              [routerLink]="subitem.routerLink"
              routerLinkActive="active"
              class="dropdown-item"
              ><i [class]="subitem.icon"></i> {{ subitem.label }}
            </a>
          </li>
          
        </div>
      </ul>
    </li>
  </ul>
